<template>
  <b-tabs class="block">
    <b-tab-item icon="pie-chart" :label="$t('emissions.t.co2e.short')">
      <b-notification :closable="false">
        {{ $t('compCarbonResultsPlotsRegulatory.info-1') }}
      </b-notification>
      <highcharts :options="BCRPieDrillDownOptions"></highcharts>
    </b-tab-item>
    <b-tab-item icon="bar-chart" :label="$t('emissions.t.co2e.short')">
      <b-notification :closable="false">
        {{ $t('compCarbonResultsPlotsRegulatory.info-1') }}
      </b-notification>
      <highcharts :options="BCRColumnDrillDownOptions"></highcharts>
    </b-tab-item>
  </b-tabs>
</template>

<script>
import '@/plugins/highcharts.js'

export default {
  name: 'PlotsRegulatory',
  props: {
    data1: {
      type: Number,
      default: 100.0
    },
    data2: {
      type: Number,
      default: 100.0
    },
    data3: {
      type: Number,
      default: 100.0
    },
    data4: {
      type: Number,
      default: 100.0
    },
    data5: {
      type: Number,
      default: 100.0
    },
    data6: {
      type: Number,
      default: 100.0
    },
    drill1: {
      type: Array,
      default: function () {
        return []
      }
    },
    drill2: {
      type: Array,
      default: function () {
        return []
      }
    },
    drill3: {
      type: Array,
      default: function () {
        return []
      }
    },
    drill4: {
      type: Array,
      default: function () {
        return []
      }
    },
    drill5: {
      type: Array,
      default: function () {
        return []
      }
    },
    drill6: {
      type: Array,
      default: function () {
        return []
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    const component = this
    return {
      BCRPieDrillDownOptions: {
        chart: {
          type: 'pie'
        },
        title: {
          text: ''
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: this.$t('t.co2e')
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              formatter () {
                return `<b>${this.point.name}:</b> ${this.y.toFixed(
                  2
                )} ${component.$t('t.co2e')}`
              }
            }
          }
        },
        tooltip: {
          pointFormatter () {
            return `<b>${this.y.toFixed(2)} ${component.$t('t.co2e')}</b>`
          }
        },
        legend: {
          enabled: false
        },
        series: [
          {
            name: 'Categories',
            colorByPoint: true,
            data: [
              {
                name: 'Cat. 1',
                y: this.data1,
                drilldown: 'cat1',
                color: '#47c78d'
              },
              {
                name: 'Cat. 2',
                y: this.data2,
                drilldown: 'cat2',
                color: '#3e8ed0'
              },
              {
                name: 'Cat. 3',
                y: this.data3,
                drilldown: 'cat3',
                color: '#Ffe08a'
              },
              {
                name: 'Cat. 4',
                y: this.data4,
                drilldown: 'cat4',
                color: '#F39200'
              },
              {
                name: 'Cat. 5',
                y: this.data5,
                drilldown: 'cat5',
                color: '#F14668'
              },
              {
                name: 'Cat. 6',
                y: this.data6,
                drilldown: 'cat6',
                color: '#363636'
              }
            ]
          }
        ],
        drilldown: {
          series: [
            {
              name: 'Cat. 1',
              id: 'cat1',
              data: this.drill1,
              zones: [
                {
                  color: '#47c78d'
                }
              ]
            },
            {
              name: 'Cat. 2',
              id: 'cat2',
              data: this.drill2,
              zones: [
                {
                  color: '#3e8ed0'
                }
              ]
            },
            {
              name: 'Cat. 3',
              id: 'cat3',
              data: this.drill3,
              zones: [
                {
                  color: '#Ffe08a'
                }
              ]
            },
            {
              name: 'Cat. 4',
              id: 'cat4',
              data: this.drill4,
              zones: [
                {
                  color: '#F39200'
                }
              ]
            },
            {
              name: 'Cat. 5',
              id: 'cat5',
              data: this.drill5,
              zones: [
                {
                  color: '#F14668'
                }
              ]
            },
            {
              name: 'Cat. 6',
              id: 'cat6',
              data: this.drill6,
              zones: [
                {
                  color: '#363636'
                }
              ]
            }
          ]
        }
      }
    }
  },
  computed: {
    BCRColumnDrillDownOptions () {
      let options = JSON.parse(JSON.stringify(this.BCRPieDrillDownOptions))
      options.chart.type = 'column'
      options.xAxis = {
        type: 'category'
      }
      options.yAxis = {
        title: {
          text: this.$t('emissions.t.co2e')
        }
      }
      options.plotOptions.series = {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y:.2f} ' + `${this.$t('t.co2e')}`
        }
      }
      options.tooltip.pointFormatter =
        this.BCRPieDrillDownOptions.tooltip.pointFormatter
      return options
    }
  }
}
</script>
